import { render, staticRenderFns } from "./CDMenuPreview.vue?vue&type=template&id=234a44b6&scoped=true"
import script from "./CDMenuPreview.vue?vue&type=script&lang=js"
export * from "./CDMenuPreview.vue?vue&type=script&lang=js"
import style0 from "./CDMenuPreview.vue?vue&type=style&index=0&id=234a44b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234a44b6",
  null
  
)

export default component.exports